<template>
    <div class="position-box">
        <div class="head">
          <img class="back" src="@/assets/icon_back.png" @click="goBack" alt="back">
          <div class="title">{{$t('langNew2.xbzq')}}</div>
          <span class="link" @click="link">{{$t('xbsg.wdsg')}}</span>
        </div>
        <div class="cotainer">
            <ul class="ul-box">
                <li class="li"  v-for="(item, index) in list" :key="index">
                    <div class="head-li">
                        <div class="head-left">
                             <img class="icon" :src="item.icon" alt="">
                            <div class="coin">{{item.currency}}</div>
                        </div>
                        <div class="head-right">
                            <div class="text"><span>{{$t('xbsg.scts')}}</span><span class="blue">{{item.lock_day}}</span></div>
                        </div>
                    </div>
                    <div class="progress-box">
                        <div class="progress" :class="{null:item.has_amount == 0}" :style="{width: 100 - item.amount_rate.split('%')[0] + '%'}"></div>
                    </div>
                    <div class="info-box">
                         <div class="text"><span class="blue">{{item.has_amount}} {{item.currency}} / </span><span>{{item.make_amount}} {{item.currency}}</span></div>
                        <div class="text text-right"><span>{{$t('xbsg.sy')}}</span> <span class="blue">{{item.amount_rate}}</span></div>
                    </div>
                    <button class="btn btn-bg" type="button" v-if="parseFloat(item.has_amount) > 0" @click="buy(item.id)">{{$t('xbsg.ljsg')}}</button>
                    <button class="btn btn-bg null" type="button" v-else>{{$t('xbsg.ysk')}}</button>
                </li>
            </ul>
            <!-- 暂无数据 -->
            <no-data v-show="isNoData"></no-data>
            <img id="goTop" class="go-top" @click="goTop" v-show="isGoTOP" src="@/assets/top.png" alt="">
        </div>
        <nav-bar navName='subscription'></nav-bar>
    </div>
</template>

<script>
import navBar from '@/components/NavBar.vue'
import noData from '@/components/noData.vue'
import VueBetterScroll from 'vue2-better-scroll'
export default {
    name: 'subscription',
    data () {
        return {
            isNoData: false,
            list: [],
            icon: '',
            isGoTOP: false,
            curDataLength: 10,
            theme: false,
            page: 1
        }
    },
    created(){

    },
    mounted() {
        this.getNewcoinsList()
    },
    methods: {
       goBack(){
        this.$router.push('/index')
       },
       getNewcoinsList(){
            let params = {
               page: this.page
            }
            this.$ajax.get('/web/getNewcoinsList',{params}).then((res) => {
                let resData = res.data.data;
                if(resData.length > 0){
                  this.curDataLength = res.length;
                  resData.forEach((item,index) => {
                      $.ajax({
                          url: this.domain + "/web/icon?c=" + item.currency,
                          type: "GET",
                          data: {},
                          success: (resIcon)=> {
                              if(typeof resIcon === 'string')  resIcon = JSON.parse(resIcon);
                              this.list = this.list.concat(item);
                              item.icon = resIcon.data;
                          },error: function(res) {
                              console.log(res)
                          }
                      })
                  });
                  this.isNoData = false;
                }else{
                  this.curDataLength = resData.length;
                  this.isNoData = true;
                }
            }).catch(function(err){
                console.log(err)
            })
        },
        buy(id){
            this.$router.push({ path: '/subscribe', query: { id: id } });
        },
        link(){
            this.$router.push('/subscriptionList')
        },
        listenScroll(e) {  //监听滚动
            let ele = e.srcElement ? e.srcElement : e.target;
            if(ele.scrollTop > 200){
                this.isGoTOP = true
            }else{
                this.isGoTOP = false
            }
            if (ele.scrollTop + ele.offsetHeight >= ele.scrollHeight) { //监听滚动到div底部
                if(this.curDataLength > 0){
                    this.page ++;
                    this.getNewcoinsList();
                }
            }
        },
        goTop(){
          $('.ul-box').animate({scrollTop:'0px'},'slow');
        }
    },
    components:{
        noData,
        navBar,
        VueBetterScroll
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
    .position-box{
      position: absolute;
      left: 0;
      top: 0;
      bottom: 1.2rem;
      width: 100%;
      height: auto;
      color: #cecece;
      font-size: .36rem;
      background: url('../assets/element-background.png') no-repeat center center;
      background-size: cover;
      overflow: hidden;
    }
    .head{
        position: fixed;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .3rem;
        top: 50%;
        width: .36rem;
        height: .66rem;
        margin-top: -.33rem;
    }
    .head .title{
        font-size: .45rem;
    }
    .head .text{
        font-size: .45rem;
    }
    .head .link{
        position: absolute;
        top: 50%;
        right: .3rem;
        padding: .12rem .24rem;
        color: #588bf8;
        font-size: .36rem;
        border: 1px solid #588bf8;
        border-radius: 3px;
        transform: translateY(-50%);
    }
    .cotainer{
        position: absolute;
        left: .42rem;
        right: .42rem;
        top: 1.6rem;
        bottom: 1.6rem;
        overflow-y: scroll;
    }
    .ul-box .li{
        margin-top: .36rem;
        padding: .48rem .42rem .72rem;
        color: #fff;
        font-size: .48rem;
        background: rgba(41,55,68,.2);
        border-radius:.28rem;
    }
    .ul-box .li .blue{
        color: #4489D7;
    }
    .ul-box .li .text{
        font-size: .36rem;
    }
    .ul-box .li .head-li{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .ul-box .li .head-li .head-left{
        display: flex;
        align-items: center;
    }
    .ul-box .li .head-li .head-left .icon{
        width: .6rem;
        height: .6rem;
    }
    .ul-box .li .head-li .head-left .coin{
        padding-left: .24rem;
    }
    .ul-box .li .progress-box{
        position: relative;
        margin: .72rem 0 .54rem;
        height: .28rem;
        background: #EDF2F8;
        border-radius: .15rem;
    }
    .ul-box .li .progress-box .progress{
        position: absolute;
        left: 0;
        width: 0%;
        height: .28rem;
        background: linear-gradient(182deg, #68ACF9, #4489D7);
        border-radius: .15rem;
    }
    .ul-box .li .progress-box .progress::after{
        position: absolute;
        right: -.54rem;
        top: -.15rem;
        content: '';
        width: .45rem;
        height: .45rem;
        border: 2px solid #fff;
        border-radius: 50%;
        background: #4489D7;
    }
    .ul-box .li .progress-box .progress.null::after{
        right: 0;
    }
    .ul-box .li .info-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .ul-box .li .btn{
        display: block;
        width: 100%;
        margin-top: .84rem;
    }
    .ul-box .li .btn.null{
        background: linear-gradient(90deg, #B9B9B9, #B9B9B9);
    }
</style>



// WEBPACK FOOTER //
// src/pages/subscription.vue